import { useEffect, useState } from "react";
import OtpVerificationForm from "../../components/ui/otp-form.ui";
import EmailLoginForm from "../../components/ui/email-form.ui";
import { useEmailResendOtpBrandHttp } from "../../hooks/http/auth/email-resend-otp.hook";
import type { IOtp } from "../../../types/models/otp.models.types";

export default function LoginPartial() {
  const [sentEmail, setSentEmail] = useState<boolean>(false);
  const [authenticationState, setAuthenticationState] = useState<IOtp>();

  const { execute: resendOtpHttp, fetching: fetchingResendOtp } =
    useEmailResendOtpBrandHttp();

  async function onResend() {
    if (!authenticationState?.id) return;
    const response = await resendOtpHttp({
      body: { id: authenticationState?.id },
    });
    if (!response.success) {
      return;
    }
    setAuthenticationState(response.data);
  }

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {}, [onResend]);

  return (
    <div className="w-full">
      {sentEmail ? (
        <OtpVerificationForm
          canResend={authenticationState?.canResend || false}
          resendIn={authenticationState?.resendIn || 0}
          loading={fetchingResendOtp}
          onResend={onResend}
          authenticationState={authenticationState as IOtp}
        />
      ) : (
        <EmailLoginForm
          setSentEmail={setSentEmail}
          sentEmail={sentEmail}
          setAuthenticationState={(value) =>
            setAuthenticationState(value as IOtp)
          }
        />
      )}
    </div>
  );
}
